/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ country: NonNullable<unknown> }} Tournaments_Filter_Remove_CountryInputs */



/**
* | output |
* | --- |
* | "Remove {country}" |
*
* @param {Tournaments_Filter_Remove_CountryInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_filter_remove_country = /** @type {((inputs: Tournaments_Filter_Remove_CountryInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Filter_Remove_CountryInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Retirer ${i?.country}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Quitar ${i?.country}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Remover ${i?.country}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rimuovi ${i?.country}`)
	return /** @type {LocalizedString} */ (`Remove ${i?.country}`)
});